import { render, staticRenderFns } from "./page_heading.vue?vue&type=template&id=2d2f6e3c"
import script from "./page_heading.vue?vue&type=script&lang=js"
export * from "./page_heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports